import { EventNoteOutlined } from '@mui/icons-material'
import { useTheme } from '@mui/material'
import { Context, memo } from 'react'
import { useTranslation } from 'react-i18next'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'
import EquipmentSectionLayout from './EquipmentSectionLayout'
import MainComponentEventsInEquipment from './MainComponentEventsInEquipment'

interface Props {
  context: Context<any> | null | undefined
  mainComponentId: EntityId
}

const MainComponentEventsSection = memo(({ context, mainComponentId }: Props) => {
  const { t } = useTranslation(['equipment'])
  const theme = useTheme()

  return (
    <EquipmentSectionLayout
      title={t('equipment-events', { ns: 'equipment' })}
      icon={<EventNoteOutlined sx={{ fontSize: '18px', color: getThemeColor(theme, MUIThemeColors.primaryMain) }} />}
      context={context}
      content={
        <MainComponentEventsInEquipment
          mainComponentId={mainComponentId}
          context={context}
          height="100%"
          autoHeight={false}
          minimalEmptyStatus
        />
      }
    />
  )
})

export default MainComponentEventsSection
